import { render } from "./HomePageEight.vue?vue&type=template&id=e4663cac"
import script from "./HomePageEight.vue?vue&type=script&lang=js"
export * from "./HomePageEight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__